import styled from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import { site } from '@panel/commons/helpers';
import exclusivenessIcon from '../../../assets/icons/exclusivenessIcon.svg';
import highExposureIcon from '../../../assets/icons/highExposureIcon.svg';
import bestConversionIcon from '../../../assets/icons/bestConversionIcon.svg';
import exclusivenessIconUB from '../../../assets/icons/exclusivenessIcon_UB.svg';
import highExposureIconUB from '../../../assets/icons/highExposureIcon_UB.svg';
import bestConversionIconUB from '../../../assets/icons/bestConversionIcon_UB.svg';

const siteId = site.id;

const Container = styled.div`
  width: 100%;
  font-style: normal;
  padding: ${({ device }) => {
    if (device === 'mobile') return '36px 18px';
    if (device === 'tablet') return '48px';
    return '';
  }};
  padding-top: 48px;
  padding-bottom: ${({ device }) => {
    if (device === 'mobile') return '32px';
    if (device === 'tablet') return '38px';
    return '56px';
  }};
  height: ${({ device }) => {
    if (device === 'mobile') return '492px ';
    if (device === 'tablet') return '360px ';
    return '';
  }};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  position: relative;
  @media (max-width: 1180px) {
    height: auto;
  }
`;

const Title = styled.div`
  width: 100%;
  font-weight: 600;
  font-size: ${({ device }) => (device === 'mobile' ? '22px' : '32px')};
  line-height: ${({ device }) => (device === 'mobile' ? '32px' : '51px')};
  text-align: center;
`;

const WrapperElement = styled.div`
  display: flex;
  flex-direction: ${({ device }) => (device !== 'mobile' ? 'row' : 'column')};
  gap: ${({ device }) => (device !== 'desktop' ? '16px' : '42px')};
  @media (max-width: 1180px) {
    flex-direction: column;
  }
`;

const Element = styled.div`
  width: ${({ device }) => {
    if (device === 'mobile') return '100%';
    if (device === 'tablet') return '545px ';
    return '400px';
  }};
  height: 108px;
  background-color: white;
  border: 1px solid ${select('midNeutralGray')};
  border-radius: 12px;
  display: flex;
  gap: 16px;
  padding: 16px 6px 16px 16px;
  .info {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  @media (max-width: 375px) {
    gap: 12px;
    padding: 16px 6px 16px 12px;
  }
`;

const selectIcon = {
  Exclusiveness: siteId === 'UBPE' ? exclusivenessIconUB : exclusivenessIcon,
  HighExposure: siteId === 'UBPE' ? highExposureIconUB : highExposureIcon,
  BestConversion: siteId === 'UBPE' ? bestConversionIconUB : bestConversionIcon
};

const Icon = styled.div`
  width: ${({ device }) => (device === 'tablet' ? '82px' : '70px')};
  height: 70px;
  background-image: url(${({ iconKey }) => selectIcon[iconKey]});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

const TitleElement = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 130%;
  font-style: normal;
`;

const TextElement = styled.p`
  width: ${({ device }) => {
    if (device === 'mobile') return '230px';
    if (device === 'tablet') return 'auto ';
    return '292px';
  }};
  font-weight: '400';
  font-size: ${({ device }) => (device === 'mobile' ? '12px' : '14px')};
  line-height: ${({ device }) => (device === 'mobile' ? '19px' : '22px')};
  white-space: break-spaces;
  @media (max-width: 375px) {
    width: 238px;
  }
`;

export { Container, Title, WrapperElement, Element, Icon, TitleElement, TextElement };
